import React from "react";

export const Contact = (props) => {
  return (
    <div>
      <div id="contact">
        <div className="container text-center">
          <div className="section-title">
            <h2>¡Contáctame!</h2>
            <p>
              Sin formularios y sin esperas: llámame y organizamos juntos tu
              próximo instante gastronómico.
            </p>
          </div>
          <a href="tel:+34650745358" className="contact-phone">
            {props.data ? props.data.phone : "loading"}
          </a>
          <div>
            <a href="tel:+34650745358" className="btn btn-custom btn-lg">
              <i className="fa fa-phone"></i> Llama ahora
            </a>
          </div>
          <div className="social">
            <ul>
              <li>
                <a href={props.data ? props.data.instagram : "/"}>
                  <i className="fa fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href={props.data ? props.data.facebook : "/"}>
                  <i className="fa fa-facebook"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 Rosaria Morici. Design by{" "}
            <a href="https://sojobo.vercel.app/" rel="nofollow">
              Sojobo-tech
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
